import { Dictionary } from '@/types';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FilterMixin extends Vue {
  get filterValues(): Dictionary<any> {
    return {
      ...this.$route.query,
      ...this.$route.params,
    };
  }

  get filterFields() {
    const nameField = [
      {
        title: 'Название компетенции',
        code: 'name',
      },
    ];

    const programsField = [
      {
        title: 'Наличие программ',
        code: 'has_events',
        data: [
          {
            name: 'Любое количество',
            id: '',
          },
          {
            name: 'Да',
            id: '1',
          },
          {
            name: 'Нет',
            id: '0',
          },
        ],
      },
    ];

    const blocks = this.$store.state.competencesBlocks;

    const blockField = [
      {
        title: 'Блок компетенции',
        code: 'comp_block_id',
        data: [{ name: 'Любой блок', id: '', default: true }, ...blocks],
        filterable: 'auto',
      },
    ];

    return [...nameField, ...blockField, ...programsField];
  }
}



// WEBPACK FOOTER //
// ./src/pages/competences/mixins/filter-mixin.ts